import React, { useState, useEffect, useContext, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const TiempoEjecucion = () => {

  const { id } = useParams(); // id_entregable
  const navigate = useNavigate();
  const { authFetch } = useContext(AuthContext);

  const [duracion, setDuracion] = useState(0);
  const [meses, setMeses] = useState({});
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // =========================
  // CARGAR DATOS
  // =========================
const loadTiempo = useCallback(async () => {
  const res = await authFetch(
    `${ENDPOINTS.get_tiempo_ejecucion}?id_entregable=${id}`
  );

    if (res.success) {

    // duración del plan
    setDuracion(res.duracion);

    // convertir array en objeto {1: 20, 2: 60}
    const mesesObj = {};

    res.data.forEach(m => {
        mesesObj[m.month] = m.porcentaje;
    });

    setMeses(mesesObj);
    }


}, [authFetch, id]);
useEffect(() => {
  loadTiempo();
}, [loadTiempo]);



  // =========================
  // GUARDAR MES
  // =========================
  const handleGuardar = async (month) => {

    const porcentaje = parseFloat(meses[month] || 0);

    if (porcentaje < 0) {
      setError("El porcentaje no puede ser negativo");
      return;
    }

    const res = await authFetch(ENDPOINTS.create_tiempo_ejecucion, {
      method: "POST",
      body: JSON.stringify({
        id_entregable: id,
        month: month,
        porcentaje: porcentaje
      })
    });

    if (!res.success) {
      setError(res.message);
      return;
    }

    setSuccess("Mes actualizado correctamente");
    loadTiempo();
  };

  // =========================
  // CALCULAR TOTAL
  // =========================
  const total = Object.values(meses)
    .reduce((sum, val) => sum + parseFloat(val || 0), 0);

  return (
    <div className="container mt-4 p-4">

      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3>Tiempo de Ejecución</h3>
          <p className="text-muted">ID Entregable: {id}</p>
        </div>

        <button
          className="btn btn-outline-pink"
          onClick={() => navigate(-1)}
        >
          ← Volver
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <div className="card p-4 shadow-sm">

        <h5 className="mb-4">Distribución mensual</h5>

        {Array.from({ length: duracion }, (_, i) => i + 1).map(month => (
          <div
            key={month}
            className="row mb-3 align-items-center"
          >
            <div className="col-md-3">
              <strong>Mes {month}</strong>
            </div>

            <div className="col-md-5">
              <input
                type="number"
                className="form-control"
                placeholder="% avance"
                min="0"
                value={meses[month] || ""}
                onChange={(e) =>
                  setMeses(prev => ({
                    ...prev,
                    [month]: e.target.value
                  }))
                }
              />
            </div>

            <div className="col-md-4">
              <button
                className="btn btn-outline-pink w-100"
                onClick={() => handleGuardar(month)}
              >
                Guardar Mes
              </button>
            </div>
          </div>
        ))}

        <hr />

        <div className="text-end fw-bold">
          Total acumulado: {total.toFixed(2)}%
        </div>

        {total > 100 && (
          <div className="alert alert-warning mt-2">
            El total supera el 100%
          </div>
        )}

      </div>

    </div>
  );
};

export default TiempoEjecucion;
